export const AdvocacyData = [
  [ 'Австралия', '0.6', '0.4', '0.8', '1' ],
  [ 'АСЕАН', '0.54', '0.452', '0.8', '1.1' ],
  [ 'Бангладеш', '0.5', '0.5', '0.8', '1' ],
  [ 'Бруней Даруссалам', '0.6', '0.4', '0.8', '1' ],
  [ 'Вануату', '0.5', '0.4', '0.8', '1' ],
  [ 'Восточный Тимор', '0.5', '0.4', '0.8', '1' ],
  [ 'Вьетнам', '0.6', '0.4', '0.8', '1' ],
  [ 'Гонконг', '0.2', '0.8', '0.8', '1' ],
  [ 'ЕАЭС', '0.4', '0.5', '0.6', '1' ],
  [ 'Евросоюз', '0.6', '0.4', '0.8', '1' ],
  [ 'Индия', '0.6', '0.4', '0.8', '1' ],
  [ 'Индонезия', '0.5', '0.48', '0.8', '1.2' ],
  [ 'Камбоджа', '0.5', '0.4', '0.8', '1' ],
  [ 'Канада', '0.6', '0.4', '0.8', '1' ],
  [ 'Кирибати', '0.5', '0.4', '0.8', '1' ],
  [ 'Китай', '0.2', '0.8', '0.7', '1' ],
  [ 'КНДР', '0.1', '0.1', '0.1', '1' ],
  [ 'Лаос', '0.5', '0.48', '0.8', '1.2' ],
  [ 'Макао', '0.2', '0.8', '0.8', '1' ],
  [ 'Малайзия', '0.6', '0.48', '0.8', '1.2' ],
  [ 'Маршалловы Острова', '0.5', '0.4', '0.8', '1' ],
  [ 'Мексика', '0.6', '0.4', '0.8', '1' ],
  [ 'Микронезия', '0.5', '0.4', '0.8', '1' ],
  [ 'Монголия', '0.5', '0.5', '0.8', '1' ],
  [ 'Мьянма', '0.6', '0.48', '0.8', '1.2' ],
  [ 'Науру', '0.5', '0.4', '0.8', '1' ],
  [ 'Ниуэ', '0.5', '0.4', '0.8', '1' ],
  [ 'Новая Зеландия', '0.6', '0.4', '0.8', '1' ],
  [ 'Острова Кука', '0.5', '0.4', '0.8', '1' ],
  [ 'Пакистан', '0.5', '0.98', '0.8', '1.4' ],
  [ 'Палау', '0.5', '0.4', '0.8', '1' ],
  [ 'Папуа-Новая Гвинея', '0.5', '0.5', '0.8', '1' ],
  [ 'Перу', '0.6', '0.4', '0.8', '1' ],
  [ 'Республика Корея', '0.5', '0.5', '0.8', '1' ],
  [ 'Россия', '0.5', '0.6', '0.8', '1' ],
  [ 'Самоа', '0.5', '0.4', '0.8', '1' ],
  [ 'Сингапур', '0.6', '0.4', '0.8', '1' ],
  [ 'Соломоновы Острова', '0.5', '0.4', '0.8', '1' ],
  [ 'США', '0.8', '0.2', '0.5', '1' ],
  [ 'Тайвань', '0.6', '0.3', '0.8', '1' ],
  [ 'Таиланд', '0.5', '0.4', '0.8', '1' ],
  [ 'Тонга', '0.5', '0.4', '0.8', '1' ],
  [ 'Тувалу', '0.5', '0.4', '0.8', '1' ],
  [ 'Фиджи', '0.5', '0.4', '0.8', '1' ],
  [ 'Филиппины', '0.4', '0.6', '0.8', '1' ],
  [ 'Чили', '0.6', '0.4', '0.8', '1' ],
  [ 'Шри-Ланка', '0.5', '0.6', '0.8', '1.2' ],
  [ 'Япония', '0.6', '0.4', '0.8', '1' ]
];
